<template>
  <div
    class="external-web-content-container"
    v-if="$store.getters['brand/brandCustomModuleLink']"
  >
    <overlay-loading :loading="loading">
      <template #content>
        <!-- <iframe
          :src="externalLink"
          class="external-web-content-iframe animate_duration animate__fadeIn"
          :style="{ height: initialHeightIFrame + 'px' }"
          @load="onLoadIframe"
          allow="camera"
        ></iframe> -->
        <iframe
          :src="externalLink"
          class="external-web-content-iframe animate_duration animate__fadeIn"
          @load="onLoadIframe"
          allow="camera"
        ></iframe>
      </template>
    </overlay-loading>
  </div>
</template>

<script>
import {
  onBeforeMount,
  onBeforeUpdate,
  ref,
  getCurrentInstance,
} from "@vue/composition-api";
import OverlayLoading from "@/views/components/loading/OverlayLoading.vue";
import router from "@/router";
import store from "@/store";
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import { initialAbility } from "@/libs/acl/config";
import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"
export default {
  components: { OverlayLoading },
  setup() {
    const { decodeToken } = useDecodeToken();
    const { getPermissionModuleActive, getActiveModule } = usePermissionByAccount()
    const initialHeightIFrame = ref("");
    const loading = ref(true);
    const externalLink = ref("");

    const vm = getCurrentInstance().proxy;

    onBeforeMount(() => {
      // 62.98px + 46.9px + 2rem
      initialHeightIFrame.value = window.innerHeight - 140;
      if (store.getters["brand/brandCustomModuleLink"]) {
        return fetchCustomPage();
      }
    });

    onBeforeUpdate(() => {
      const isTokenExp = decodeToken()?.exp < new Date() / 1000;
      if (isTokenExp) {
        return forceLogOut();
      }
      return fetchCustomPage();
    });

    const fetchCustomPage = () => {
      // let url = store.getters["brand/brandCustomModuleLink"];
      store
        .dispatch("brand/fetchTokenByBrand")
        .then((response) => {
          // ส่ง credential ให้ back-office ผ่าน localStorage แทน query string
          // ทั้งสองแอปอยู่ origin เดียวกันจึงใช้ localStorage ร่วมกันได้
          // (ค่าเหล่านี้เคยถูกเขียนลง localStorage โดย back-office เองอยู่แล้ว
          //  ต่างกันแค่ตอนนี้ไม่ต้องผ่าน URL ซึ่งติด browser history / access log)
          localStorage.setItem("bp_access_token", response.accessToken);
          localStorage.setItem("bp_refresh_token", response.refreshToken);
          localStorage.setItem(
            "permission_access",
            JSON.stringify(getPermissionModuleActive(getActiveModule()))
          );

          externalLink.value = `${process.env.VUE_APP_ENDPOINT_FRONT_MBK}/back-office/?brandRef=${response.brandRef}&page=${encodeURI(router.currentRoute.path)}`;
        })
        .finally(() => {});
    };

    const onLoadIframe = () => {
      loading.value = false;
    };

    const forceLogOut = () => {
      let brands = JSON.parse(
        localStorage.getItem(window.brandLocalStorage)
      ).filter((o) => {
        return o.brandRef != sessionStorage.getItem(window.brandSessionStorage);
      });

      localStorage.setItem(window.brandLocalStorage, JSON.stringify(brands));
      // Reset ability
      vm.$ability.update(initialAbility);

      vm.$router.push({ name: "auth-login" });
    };

    return {
      initialHeightIFrame,
      loading,
      externalLink,
      onLoadIframe,
    };
  },
};
</script>

<style scoped>
/* .external-web-content-container {
  width: 100%;
  height: 600px;
}
.external-web-content-iframe {
  width: 100%;
  height: 100%;
  border: unset !important;
} */
.external-web-content-container {
  width: 100%;
}
.external-web-content-iframe {
  width: 100%;
  min-height: calc(100vh - 2rem - 4.45rem - 2rem - 2rem);
  border: unset !important;
}
</style>
